const arrays = {
  converteParaParametroGET<T>(array: T[], parametro: string): string {
    if (array.length > 0) {
      const nomeParametro = parametro + '='
      const nomeParametroJoin = '&' + nomeParametro

      return nomeParametro + array.join(nomeParametroJoin)
    } else {
      return ''
    }
  },
}

export default arrays
